import { createApi } from '@reduxjs/toolkit/query/react'
import { AddDriverPayload, Driver, UpdateDriverPayload } from './drivers.type'
import { createBaseQueryWithReauth } from 'store/auth/base-query-with-reauth'
import { subscriptionsApi } from 'store/subscriptions/subscriptions.api'

const baseUrl = `${process.env.REACT_APP_ONBOARDING_SERVICE_API}`

export const driversApi = createApi({
  reducerPath: 'driversApi',
  baseQuery: createBaseQueryWithReauth(baseUrl!),
  tagTypes: ['Drivers'],
  endpoints: (builder) => ({
    listDrivers: builder.query<
      Driver[],
      { userId: string; driverAppStatus?: string }
    >({
      query: ({ userId, driverAppStatus }) => {
        const params = new URLSearchParams()
        params.append('userId', userId)
        if (driverAppStatus) {
          params.append('driverAppStatus', driverAppStatus)
        }
        return {
          url: `oapi/v1/drivers?${params.toString()}`,
        }
      },
      providesTags: ['Drivers'],
    }),

    addDriver: builder.mutation<Driver, AddDriverPayload>({
      query: (body) => ({
        url: 'oapi/v1/drivers',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Drivers'],
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled
          dispatch(subscriptionsApi.util.invalidateTags(['Subscription']))
        } catch {
          return
        }
      },
    }),

    deleteDriver: builder.mutation<Driver, string>({
      query: (id) => ({
        url: `oapi/v1/driver/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Drivers'],
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled
          dispatch(subscriptionsApi.util.invalidateTags(['Subscription']))
        } catch {
          return
        }
      },
    }),

    updateDriver: builder.mutation<
      Driver,
      { driverId: string } & UpdateDriverPayload
    >({
      query: ({ driverId, ...body }) => ({
        url: `oapi/v1/drivers/${driverId}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Drivers'],
    }),
  }),
})

export const {
  useListDriversQuery,
  useLazyListDriversQuery,
  useAddDriverMutation,
  useDeleteDriverMutation,
  useUpdateDriverMutation,
} = driversApi
